module.exports = __webpack_public_path__ + "media/images/reply_none-78ae9394dea539b7d6c6e4819ca3f3e4.png";